import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";

import { breakDownSchema } from "../../Helper/validationSchemas";
import { useParams } from "react-router-dom";
import CustomInput from "../inputs/CustomInput";
import { submitBreakDown } from "../../store/actions/disbursement/submitBreakDown";

function ETCBreakDownModal({
  open,
  cycle,
  onClose,
  investment_category_id,
  refresh,
  invID,
  setOpenModal,

  currency,
}) {
  const { id: investmentId } = useParams();
  const [showMembers, setShowMembers] = useState(false);
  const loading = useSelector((state) => state?.disbursement?.pending);

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const data = {
      investment_category_id: cycle?.id || investment_category_id,
      investment_product_id: invID,
      total_current_investment_value: values?.total_current_investment_value,
      percentage: values?.percentage,
    };

    dispatch(
      submitBreakDown({
        data,
        callback: () => {
          form.setSubmitting(false);
          setOpenModal(false);
        },
        fail: () => {
          form.setSubmitting(false);
        },
      }),
    );
  };

  const form = useFormik({
    initialValues: {
      percentage: 0,
      total_current_investment_value: 0,
      currency: { value: currency, label: currency },

      investment_product_id: investmentId,
    },
    onSubmit: handleSubmit,
    validationSchema: breakDownSchema,
  });

  useEffect(() => {
    form.setFieldValue("currency", { value: currency, label: currency });
  }, [currency]);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="custom-modal-title"
        aria-describedby="custom-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 2,
          }}
        >
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              top: 19,
              right: 10,
            }}
            onClick={onClose}
          >
            <ClearIcon />
          </IconButton>

          <div className="w-full p-5">
            <div>
              <h1 className="font-[500] text-2xl mb-4">Loss Break Down</h1>

              <div className="mb-4 lg:mb:0 lg:pl-0 lg:mr-8 w-full">
                <p className="">Total Current Investment Value</p>
                <CustomInput
                  id="total_current_investment_value"
                  width="100%"
                  form={form}
                  type="currency"
                  placeholder={"Enter Value"}
                  height="12px"
                  mt="10"
                  mb="2px"
                  mr="10px"
                  borderRadius={"4px"}
                  className="mobile-input-width"
                />
              </div>
              <div className="mb-4 lg:mb:0 lg:pl-0 lg:mr-8 w-full">
                <p className="">Percentage</p>
                <CustomInput
                  id="percentage"
                  width="100%"
                  form={form}
                  type="number"
                  placeholder={"Enter Percentage"}
                  height="12px"
                  mt="10"
                  mb="2px"
                  mr="10px"
                  borderRadius={"4px"}
                  className="mobile-input-width"
                />
              </div>

              <div className="flex mt-10 w-full items-center">
                <CustomButton
                  variant="outlined"
                  customColor="#fff"
                  children="Cancel"
                  width="100%"
                  onClick={onClose}
                  height="50px"
                  borderColor="#D0D5DD"
                  margin="0px 25px 0px 0px"
                  color="#159AA8"
                  iconWidth="22px"
                />

                <CustomButton
                  variant="contained"
                  customColor="#159AA8"
                  loading={loading || form.isSubmitting}
                  children={
                    form?.values?.beneficiary?.value === "selected_users"
                      ? "Continue"
                      : "Submit"
                  }
                  width="100%"
                  height="50px"
                  padding="10px"
                  disabled={!form?.isValid || loading}
                  onClick={form.handleSubmit}
                />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ETCBreakDownModal;
